module.exports = __webpack_public_path__ + "img/gb56.prt.147b9607.jpg";